export enum PromoCodeType {
  My = 'my',
  Entered = 'entered',
  Applied = 'applied',
  Available = 'available'
}
